import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../../../environments/environment';
import { appModernizationDetails } from '../../../../../config';
import { Observable } from 'rxjs';
import { CommonService } from './common.service';
import { SharedAuthService } from '../../../../../shared/shared.auth.service';
import { BULK_MAINTENANCE_ERROR_MESSAGES } from './bulk-maintenance-error-messages';

@Injectable({
  providedIn: 'root'
})

export class PrimaryUploadService {
   private requiredFields = [
  { key: 'Update Type', message: BULK_MAINTENANCE_ERROR_MESSAGES.PRIMARY_UPLOAD.UPDATE_TYPE_EMPTY, nullCheck: true },
  { key: 'Update Type', message: BULK_MAINTENANCE_ERROR_MESSAGES.PRIMARY_UPLOAD.UPDATE_TYPE_INVALID, validCheck: true },
  { key: 'GLOBAL APP ID', message: BULK_MAINTENANCE_ERROR_MESSAGES.PRIMARY_UPLOAD.APP_ID_EMPTY, nullCheck: true },
  { key: 'LOB ID', message: BULK_MAINTENANCE_ERROR_MESSAGES.PRIMARY_UPLOAD.LOB_ID_EMPTY, nullCheck: true },
  { key: 'Sub LOB ID', message: BULK_MAINTENANCE_ERROR_MESSAGES.PRIMARY_UPLOAD.SUB_LOB_ID_EMPTY, nullCheck: true },
  { key: 'Group Model', message: BULK_MAINTENANCE_ERROR_MESSAGES.PRIMARY_UPLOAD.GROUP_MODEL_EMPTY, nullCheck: true },
  { key: 'Capability L0 Id', message: BULK_MAINTENANCE_ERROR_MESSAGES.PRIMARY_UPLOAD.CAPABILITY_L0_ID_EMPTY, nullCheck: true },
  { key: 'Capability L1 Id', message: BULK_MAINTENANCE_ERROR_MESSAGES.PRIMARY_UPLOAD.CAPABILITY_L1_ID_EMPTY, nullCheck: true }
    ];

    private primaryUploadRequiredHeaders = [
        'Update Type',
        'GLOBAL APP ID', 'LOB ID', 
        'Sub LOB ID', 'Organization ID' ,'Capability L0 Id', 'Group Model', 
        'Capability L1 Id', 'Capability L2 Id', 'Capability L3 Id',
        'Primary Status'
    ]
    private apiUrl: string;
    private largeapiUrl: string = environment.LargeapiUrl;
    private config: any;
   primaryUploadAllowedUpdateTypes: string[] = ['U'];
  largeOPsUrl: string;
    constructor(private commonService: CommonService, private http: HttpClient,private sharedAuthService: SharedAuthService) {
        this.config = appModernizationDetails;
        this.apiUrl = environment.apiUrl;
        this.largeOPsUrl = environment.LargeapiUrl;
    }

  public checkRequiredHeaders(headers: string[]) {
    const missingHeader = this.primaryUploadRequiredHeaders.filter(item => !headers.includes(item));
    return missingHeader;
  }

  public modifyHeaders(headers: string[]) {
    const newHeaders = [];
    for (const item of headers) {
      let isMatch = false;
      for (const data of this.primaryUploadRequiredHeaders) {
        if (item?.trim().toLowerCase() == data.toLowerCase()) {
          isMatch = true;
          newHeaders.push(data);
          break;
        }
      }
      if (!isMatch) {
        newHeaders.push(item);
      }
    }
    return newHeaders;
  }
  public modifyUploadedData(data: any[], headers: string[]) {
    function capitalizeWords(sentence) {
      return sentence.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
    }
    const updatedData = [];
    for (const item of data) {
      const newData = {};
      for (const key of Object.keys(item)) {
        const header = headers.find(ele => ele.toLowerCase() == key?.trim().toLowerCase());
        if (item[key] != null) {
          item[key] = capitalizeWords(item[key]);
        }
        newData[header] = item[key];
      }
      updatedData.push(newData);
    }

    return updatedData;
  }

  public validateRecordService(excelData: any[]) {
    const captureAllError = [];
    let duplicateRecords = [];


    let validaterecords = [];
    const clonedExcelData = excelData.map(el => ({ ...el }));
    if (clonedExcelData && clonedExcelData.length > 0) {
      const { uniqueRecords, duplicates } = this.ValidatePrimaryData(clonedExcelData);

      validaterecords = uniqueRecords
      duplicateRecords = duplicates;
    }
    return  [validaterecords, duplicateRecords];
  }

  public validateUniqueRecordsForPrimaryUpload(uniqueRecords: any) {
    uniqueRecords.forEach((row: any, index: number) => {
      const validatedRecord = this.validateExcelDataForPrimaryUploadRules(row, index);
      if (!validatedRecord.status) {
        row['Status'] = 'Fail';
        row['Message'] = validatedRecord.message;
      } else {
        if (row['Primary Status'].toLowerCase() == 'yes') {
          row['Primary Status'] = 'Yes'
        }
        if (row['Primary Status'].toLowerCase() == 'no') {
          row['Primary Status'] = 'No'
        }
        row['Status'] = 'Success';
        row['Message'] = '';
      }
      row['createdById'] = sessionStorage.getItem('MsId');
      row['createdByName'] = JSON.parse(sessionStorage.getItem('currentUser'));
      row['ASK GLOBAL ID'] = row['GLOBAL APP ID'];
    });

    return uniqueRecords;
  }

  public ValidatePrimaryData(dataset: any[]) {
    try {
      if (dataset && dataset.length) {
        //find duplicates records
        const uniqueKeys = this.commonService.getPrimaryUploadRequiredHeaders();
        const { uniques, duplicates } = this.commonService.findDuplicatesAndUniqueRecords(dataset, uniqueKeys);

        //find unique records by validating excel data
        const uniqueRecords = this.validateUniqueRecordsForPrimaryUpload(uniques);

        return { uniqueRecords, duplicates };
      } else {
        console.error(BULK_MAINTENANCE_ERROR_MESSAGES.COMMON.ZERO_RECORDS_FOUND);
      }
    } catch (e) {
      console.error(BULK_MAINTENANCE_ERROR_MESSAGES.COMMON.VALIDATION_FAILED_PREFIX, e);
    }
  }

  public validateExcelDataForPrimaryUploadRules(excelRow: any[], index: number) {
    let obj = this.commonService.initializeValidationObject();

    // Check if row already has a fail status
    if (excelRow['Status'] && excelRow['Status'].toLowerCase() == 'fail') {
      return this.commonService.createErrorObject(index, excelRow['Message']);
    }

    // Perform all validations
    obj = this.commonService.validateFieldsAndUpdateType(this.requiredFields, excelRow, index, obj, this.primaryUploadAllowedUpdateTypes);
    obj = this.validateCapabilityHierarchy(excelRow, index, obj);
    obj = this.validatePrimaryStatus(excelRow, index, obj);

    return obj.status === false ? obj : { status: true, index, message: "" };
  }

 

  private validateCapabilityHierarchy(excelRow: any[], index: number, obj: any) {
    const capabilityL2NullCheck = this.commonService.NullCheck(excelRow['Capability L2 Id']);
    const capabilityL3NullCheck = this.commonService.NullCheck(excelRow['Capability L3 Id']);

    if (capabilityL2NullCheck && !capabilityL3NullCheck) {
      obj = {
        status: false,
        index,
        message: this.commonService.appendMultipleMessage(
          obj,
          BULK_MAINTENANCE_ERROR_MESSAGES.PRIMARY_UPLOAD.INVALID_CAPABILITY_HIERARCHY
        )
      };
    }
    return obj;
  }

  private validatePrimaryStatus(excelRow: any[], index: number, obj: any) {
    const primaryStatusNullCheck = this.commonService.NullCheck(excelRow['Primary Status']);
    const isValidPrimaryStatus = this.commonService.allowedValueCheck(excelRow['Primary Status'], ['yes', 'no']);
    if (primaryStatusNullCheck) {
      obj = {
        status: false,
        index,
        message: this.commonService.appendMultipleMessage(
          obj,
          BULK_MAINTENANCE_ERROR_MESSAGES.PRIMARY_UPLOAD.PRIMARY_STATUS_EMPTY
        )
      };
    }
    if (!isValidPrimaryStatus) {
      obj = {
        status: false,
        index,
        message: this.commonService.appendMultipleMessage(
          obj,
          BULK_MAINTENANCE_ERROR_MESSAGES.PRIMARY_UPLOAD.PRIMARY_STATUS_INVALID
        )
      };
    }
    return obj;
  }

  public primaryUploadPreview(body: any): Observable<any> {
    const url = this.largeapiUrl + this.config.routerpath.primaryUploadBulkImport;
    const headers = new HttpHeaders({
      'Content-Type': ''
    });
    const options = {
      headers: headers
    }
    return this.http.put<any>(url, body, options);
  }

  public primaryUploadSubmit(body: any): Observable<any> {
    const url = this.largeapiUrl + this.config.routerpath.primaryUploadBulkImportUpdate;
    const headers = new HttpHeaders({
      'Content-Type': ''
    });
    const options = {
      headers: headers
    }
    return this.http.put<any>(url, body, options);
  }

}